module.exports = 'hallo';
